import { defineComponent as _defineComponent } from 'vue'
import AppButton from './AppButton.vue';
  import AppButtonOutlined from './AppButtonOutlined.vue';

  import iconMenuVue from '@/icons/icon-menu.vue';
  import { ref } from 'vue';
  import IconClose from '@/icons/icon-close.vue';
  import { useAuthStore } from '@/stores/authStore';

  // eslint-disable-next-line
  
export default /*#__PURE__*/_defineComponent({
  __name: 'TheNavbarMenuMobile',
  setup(__props, { expose: __expose }) {
  __expose();

  const openMenu = ref(false);
  const authStore = useAuthStore();
  const switchMenu = () => (openMenu.value = !openMenu.value);

const __returned__ = { openMenu, authStore, switchMenu, AppButton, AppButtonOutlined, iconMenuVue, ref, IconClose, get useAuthStore() { return useAuthStore } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})